import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { IconKebab } from '@flixbus/honeycomb-icons-react';
import {
	Button,
	DataTable,
	DataTableHead,
	DataTableRow,
	DataTableCell,
	Dropdown,
	DropdownItem,
} from '@flixbus/honeycomb-react';

import { crewMemberNoData } from '../const';
import DeleteReplacement from '../DeleteReplacement';
import { holdDownsText } from './text';
import { useHoldDowns } from './useHoldDowns';

import styles from './styles.module.css';

const HoldDowns = observer(() => {
	const {
		employeeInfo,
		holdDownRows,
		selectedHoldDownId,
		showDeleteReplacement,
		hasHoldDown,
		handleAddClick,
		handleDeleteClick,
		handleCloseDeleteReplacement,
		handleEditClick,
		handleShowWorkAssignmentsClick,
	} = useHoldDowns();

	const links = (row) => {
		const isReplacedHoldDown = row.originalCrewMember?.id === employeeInfo?.id;

		return [
			isReplacedHoldDown ? null : (
				<DropdownItem key="edit" Elem="button" onClick={() => handleEditClick(row.id)}>
					{holdDownsText.actions.edit}
				</DropdownItem>
			),
			<DropdownItem
				key="showWa"
				Elem="button"
				onClick={() => handleShowWorkAssignmentsClick(row.id)}
			>
				{holdDownsText.actions.showWorkAssignments}
			</DropdownItem>,
			isReplacedHoldDown ? null : <DropdownItem key="divider" divider />,
			isReplacedHoldDown ? null : (
				<DropdownItem
					key="delete"
					Elem="button"
					extraClasses={styles.deleteItem}
					onClick={() => handleDeleteClick(row.id)}
				>
					{holdDownsText.actions.delete}
				</DropdownItem>
			),
		].filter(Boolean);
	};

	return (
		<>
			<div className={styles.container}>
				<Button extraClasses={styles.addButton} appearance="primary" onClick={handleAddClick}>
					{holdDownsText.addHolddownButton}
				</Button>

				{!hasHoldDown && <p className={styles.emptyState}>{crewMemberNoData}</p>}

				{hasHoldDown && (
					<DataTable
						headers={
							<DataTableHead>
								<DataTableRow>
									<DataTableCell scope="col" style={{ width: '160px' }}>
										{holdDownsText.tableHeaders.startDate}
									</DataTableCell>
									<DataTableCell scope="col" style={{ width: '160px' }}>
										{holdDownsText.tableHeaders.endDate}
									</DataTableCell>
									<DataTableCell scope="col" style={{ width: '180px' }}>
										{holdDownsText.tableHeaders.driverToReplace}
									</DataTableCell>
									<DataTableCell scope="col" style={{ width: '200px' }}>
										{holdDownsText.tableHeaders.createdBy}
									</DataTableCell>
									<DataTableCell scope="col" style={{ width: '160px' }}>
										{holdDownsText.tableHeaders.created}
									</DataTableCell>
									<DataTableCell scope="col">{holdDownsText.tableHeaders.note}</DataTableCell>
									<DataTableCell scope="col" style={{ width: '40px' }} />
								</DataTableRow>
							</DataTableHead>
						}
					>
						{holdDownRows.map((row) => {
							return (
								<DataTableRow key={row.id}>
									<DataTableCell className={styles.cell}>{row.startDate}</DataTableCell>
									<DataTableCell className={styles.cell}>{row.endDate}</DataTableCell>
									<DataTableCell className={styles.cell}>
										<Link
											to={`/crew-management/${row.driverId}`}
											className={styles.profileLink}
											target="_blank"
											rel="noopener noreferrer"
										>
											{row.driver}
										</Link>
									</DataTableCell>
									<DataTableCell className={styles.cell}>{row.createdBy}</DataTableCell>
									<DataTableCell className={styles.cell}>{row.created}</DataTableCell>
									<DataTableCell className={styles.noteCell}>{row.note}</DataTableCell>
									<DataTableCell className={styles.actionsCell}>
										<Dropdown yPosition="top" xPosition="left" links={links(row)}>
											<Button
												appearance="link"
												display="square"
												size="sm"
												aria-label={holdDownsText.actions.moreOptionsAriaLabel}
												extraClasses={styles.moreOptionsButton}
											>
												<IconKebab />
											</Button>
										</Dropdown>
									</DataTableCell>
								</DataTableRow>
							);
						})}
					</DataTable>
				)}
			</div>
			{showDeleteReplacement && selectedHoldDownId && (
				<DeleteReplacement holdDownId={selectedHoldDownId} onClose={handleCloseDeleteReplacement} />
			)}
		</>
	);
});

export default HoldDowns;
